var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zt-block"},[_c('div',{staticClass:"zt-block-head"},[_vm._v("奖项证书")]),_c('div',{staticClass:"zt-block-content"},[_c('UploadImgs',{attrs:{"prefix":"comp/aptitude/prize","limit":10},model:{value:(_vm.hbs),callback:function ($$v) {_vm.hbs=$$v},expression:"hbs"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }